<template>
  <section id="contact" class="contact section">
    <div class="container">
      <div class="contact__inner">
        <div class="contact__form-wrap">
          <h3 class="contact__title">预约产品演示</h3>
          <!--<p class="contact__subtitle">填写信息，我们将在1个工作日内与您联系</p>

          <form class="contact__form" @submit.prevent="handleSubmit">
            <div class="contact__row">
              <div class="contact__field">
                <label>姓名 <span>*</span></label>
                <input v-model="form.name" type="text" placeholder="请输入您的姓名" required>
              </div>
              <div class="contact__field">
                <label>手机号 <span>*</span></label>
                <input v-model="form.phone" type="tel" placeholder="请输入手机号" required>
              </div>
            </div>
            <div class="contact__row">
              <div class="contact__field">
                <label>单位名称 <span>*</span></label>
                <input v-model="form.company" type="text" placeholder="请输入单位名称" required>
              </div>
              <div class="contact__field">
                <label>职务</label>
                <input v-model="form.position" type="text" placeholder="请输入职务">
              </div>
            </div>
            <div class="contact__field">
              <label>咨询产品 <span>*</span></label>
              <select v-model="form.product" required>
                <option value="" disabled>请选择产品</option>
                <option v-for="opt in productOptions" :key="opt" :value="opt">{{ opt }}</option>
              </select>
            </div>
            <div class="contact__field">
              <label>留言</label>
              <textarea v-model="form.message" rows="4" placeholder="请描述您的需求"></textarea>
            </div>
            <button type="submit" class="btn btn-blue contact__submit">提交预约</button>
          </form>

          <div v-if="submitted" class="contact__success">
            提交成功！我们将尽快与您联系。
          </div>-->
		  <div class="contact__side">
		    
		    <div class="contact__channel">
		      <div class="contact__channel-icon wechat2">💬</div>
		      <h4>微信咨询</h4>
		      <p>扫码添加微信</p>
		      <img :src="wechatQr" alt="微信二维码" class="contact__qr">
		    </div>
		    <div class="contact__channel">
		      <div class="contact__channel-icon phone">📞</div>
		      <h4>电话咨询</h4>
		      <p>{{ company.phone }}</p>
		      <p>{{ company.phone2 }}</p>
		    </div>
		  </div>
        </div> 

       
      </div>
    </div>
  </section>
</template>

<script>
import { company, productOptions } from '../data/site'
import wechatQr from '../assets/img/wx_qjq.png'

export default {
  name: 'ContactForm',
  props: {
    defaultProduct: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      company,
      productOptions,
      wechatQr,
      form: {
        name: '',
        phone: '',
        company: '',
        position: '',
        product: this.defaultProduct || '',
        message: ''
      },
      submitted: false
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true
      this.form = {
        name: '',
        phone: '',
        company: '',
        position: '',
        product: this.defaultProduct || '',
        message: ''
      }
      setTimeout(() => {
        this.submitted = false
      }, 4000)
    }
  }
}
</script>

<style scoped>
.contact {
  background: #fff;
}

.contact__inner {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 48px;
  align-items: start;
}

.contact__title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 8px;
}

.contact__subtitle {
  font-size: 14px;
  color: #888;
  margin-bottom: 32px;
}

.contact__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.contact__field {
  margin-bottom: 16px;
}

.contact__field label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 6px;
}

.contact__field label span {
  color: #e53935;
}

.contact__field input,
.contact__field select,
.contact__field textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #dde3ed;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  background: #fff;
  transition: border-color 0.2s;
  font-family: inherit;
}

.contact__field input:focus,
.contact__field select:focus,
.contact__field textarea:focus {
  outline: none;
  border-color: #0052d9;
}

.contact__submit {
  width: 100%;
  justify-content: center;
  padding: 14px;
  font-size: 16px;
  margin-top: 8px;
}

.contact__success {
  margin-top: 16px;
  padding: 12px 16px;
  background: #e8f8ef;
  color: #0a6e4e;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
}

.contact__side {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.contact__channel {
  flex: 1;
  background: #f7f9fc;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  border: 1px solid #eef1f6;
}

.contact__channel-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  margin: 0 auto 12px;
}

.contact__channel-icon.wechat {
  background: #e8f8ef;
}

.contact__channel-icon.wechat2 {
  background: #e8f8ef;
}

.contact__channel-icon.phone {
  background: #e8f0fe;
}

.contact__channel h4 {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 4px;
}

.contact__channel p {
  font-size: 13px;
  color: #666;
}

.contact__qr {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  margin: 12px auto 0;
  display: block;
  object-fit: cover;
}

@media (max-width: 768px) {
  .contact__inner {
    grid-template-columns: 1fr;
  }

  .contact__row {
    grid-template-columns: 1fr;
  }

  .contact__side {
    flex-direction: column;
  }
}
</style>
